import ArSummaryReduxModel from 'src/model/modules/arSummary.model';
import ArSummaryModel from 'src/model/arSummary.model';

const ArSummarySel = (state: any): ArSummaryReduxModel => state.arSummary;

export const contentSel = (state: any): ArSummaryModel =>
  ArSummarySel(state).content;
export const getArSummaryIsPending = (state: any): boolean =>
  ArSummarySel(state).getArSummaryIsPending;
